<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-fan`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c9.941 0 18 8.059 18 18 0 9.265-7 16.895-16 17.89V42h7a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h7v-4.11C13 36.896 6 29.265 6 20c0-9.941 8.059-18 18-18zm0 4c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14S31.732 6 24 6zm-6.176 14.686a5.732 5.732 0 002.936 5.086l-3.09 3.786a10.242 10.242 0 01-3.307-3.483A10.25 10.25 0 0113 21.468l4.824-.782zm12.207 0l4.823.782c-.082 1.622-.55 3.2-1.363 4.607a10.245 10.245 0 01-3.308 3.483l-3.089-3.786a5.732 5.732 0 002.167-2.14 5.732 5.732 0 00.77-2.946zM24 17a3 3 0 110 6 3 3 0 010-6zm-.073-8c1.676 0 3.261.404 4.67 1.123l-1.733 4.568a5.731 5.731 0 00-2.937-.807c-1.068 0-2.07.293-2.937.807l-1.734-4.568A10.248 10.248 0 0123.927 9z"/></svg>
</template>
<script>

export default {
  name: 'IconFan',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
